import { Injectable } from '@angular/core';
import { ApiWpService } from '@mare-common/ngx-mare-auth';
import { MenuItem, MENUDELFI, MENUUSER } from '../shared/menu-items/menu-items';
import { Subject, catchError, shareReplay } from 'rxjs';
import { PlatformApiWpService } from './platform-apiwp.service';

@Injectable({
  providedIn: 'root'
})
export class WpMenuService {
  menuItemsRaw: any;
  menuItems: MenuItem[] | null = null;
  userMenuItems: MenuItem[] | null = null;
  subject!: Subject<any>;
  slugs: string = 'angular_platform,user_menu';
  useStaticMenu: boolean = true;

  constructor(
    private apiWpService: PlatformApiWpService
  ) {
   
    this.initMenu()
    .pipe(
      catchError((err: any) => {
        console.log(err);
        return err;
      })
    )
    .subscribe((menu: any) => {
    });
   }

   initMenu(): Subject<{menu: MenuItem[], user_menu: MenuItem[]}> {
     
     if (this.subject)
      return this.subject;
    this.subject = new Subject<any>();
    this.subject.pipe(
      shareReplay(1),
      catchError((err: any) => {
        console.log(err);
        return err;
      })
    );
    
    this._reloadMenu();
    
    return this.subject;
  }

  _reloadMenu() {

    if(this.useStaticMenu) {
      this.menuItems = MENUDELFI;
      this.userMenuItems = MENUUSER;
      setTimeout(() => {
        this.subject.next({menu: this.menuItems, user_menu: this.userMenuItems});
      }, 50);
      return;
    }

    let url = "msc/v1/menu";
    if (this.slugs) {
      url += "?slugs=" + this.slugs;
    }
    this.apiWpService.getRequest(url, null).then((sub: any) => {
      sub.subscribe((response: any) => {
        if (response) {
          this.menuItemsRaw = response.payload;
          this.manageMenuItems();
        }
        this.subject.next({ menu: this.menuItems, user_menu: this.userMenuItems });
      });
    });
  }

  manageMenuItems() {
    this.menuItems = new Array<MenuItem>();
    this.userMenuItems = new Array<MenuItem>();
    for (const key in this.menuItemsRaw) {
      if (Object.hasOwn(this.menuItemsRaw, key)) {
        if(key != 'angular_platform' && key != 'commerciale' && key != 'user_menu')
          continue;
        const element = this.menuItemsRaw[key];
        let menuToUse = key == 'user_menu' ? this.userMenuItems : this.menuItems;
        element.forEach((item: any,index:number) => {
          let menu: MenuItem = {
            state: item.url ? item.is_angular ? this.cleanState(item.url) : item.url : item.post_name,
            type: item.is_rewrite ? 'to-replace' : item.is_angular ? 'link' : 'url', //item.type,
            name: item.post_title,
            order: item.menu_order ? Number(item.menu_order) : index,
            icon: item.icon || item.menu_icon,
            pagetitle: item.title,
            target: item.target || '_self',
            classes: item.classes ? Array.isArray(item.classes) ? item.classes.join(' ') : item.classes : '',
            object_id: item.object_id,
            is_new: item?.is_new || false,
            show_promo: item?.show_promo || false,
            promo_text: item?.promo_text || null,
            promo_weight: Number(item?.promo_weight) || 0,

          }
          if(item.menu_item_parent && item.menu_item_parent != "0") {
            // const parent = menuToUse?.find((menu) => menu.object_id == item.menu_item_parent);
            // menu.type = 'group';
            const parent = this.findParentMenuRecursive(menuToUse, item.menu_item_parent);
            if(parent) {
              if(!parent.children)
                parent.children = new Array<MenuItem>();
              parent.children.push(menu);
            }
          } else {
            menuToUse?.push(menu);
          }
          // if(key == 'user_menu') {
          //   this.userMenuItems?.push(menu);
          // } else {
          //   this.menuItems?.push(menu);
          // }
        });
      }
    }
  }

  findParentMenuRecursive(menu: MenuItem[], object_id: string): MenuItem | null {
    let parent: MenuItem | null = null;
    menu.forEach((item) => {
      if(item.object_id == object_id) {
        parent = item;
      } else if(item.children) {
        parent = this.findParentMenuRecursive(item.children, object_id);
      }
    });
    return parent;
  }

 
  getMenuItems(): Promise<MenuItem[]> {
    return new Promise((resolve, reject) => {
      // if(this.menuItems) {
      //   resolve(this.menuItems);
      // } else {
        this.initMenu().subscribe((menu: {menu: MenuItem[], user_menu: MenuItem[]}) => {
          resolve(menu.menu);
        });
      // }
    });
  }

  getUserMenuItems(): Promise<MenuItem[]> {
    return new Promise((resolve, reject) => {
      if (this.userMenuItems) {
        resolve(this.userMenuItems);
      } else {
        this.initMenu()
        .subscribe((menu: { menu: MenuItem[], user_menu: MenuItem[] }) => {
          resolve(menu.user_menu);
        });
      }
    });
  }

  cleanState(state: string): string {
    if(state.startsWith('/'))
      state = state.substring(1);
    if(state.endsWith('/'))
      state = state.substring(0, state.length - 1);
    return state;
  }

}
